export default __webpack_public_path__ + "static/media/loader.135217a7.gif";